import type { GUID } from "../types/GUID"

/**
 * Converts a GUID (256-bit bigint) to a 32-byte Uint8Array.
 * Extracts bytes in big-endian order.
 *
 * @param guid - 256-bit identifier as bigint
 * @returns 32-byte Uint8Array representation
 *
 * @example
 * ```ts
 * import { GUIDToUint8 } from "@pdfking/tfunc"
 *
 * const guid = UUID()
 * const bytes = GUIDToUint8(guid)
 * console.log(bytes.length) // 32
 * ```
 */
export const GUIDToUint8 = (guid: GUID): Uint8Array => {
  const result = new Uint8Array(32)
  let value: bigint = guid
  for (let i = 31; i >= 0; i--) {
    result[i] = Number(value & 0xffn)
    value >>= 8n
  }
  return result
}
